/* eslint-disable prettier/prettier */
// utils/getCountries.ts
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';

// Register English locale
countries.registerLocale(enLocale);

interface CountryInfo {
    name: string;
    iso2: string;
    iso3: string;
}

export function getAllCountries(): CountryInfo[] {
    const iso2List = Object.keys(countries.getAlpha2Codes());

    return iso2List.map((iso2) => {
        const name: any = countries.getName(iso2, 'en');
        const iso3: any = countries.alpha2ToAlpha3(iso2);

        return {
            name: name || '',
            iso2,
            iso3,
        };
    });
}
